import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { CustomerForm } from 'components/Customer/Form/CustomerForm';
import ErrorList from 'components/Form/ErrorList/ErrorList';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { RightColumn } from 'components/Layout/TwoColumns/RightColumn/RightColumn';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import { MarketplaceInfo } from 'components/Marketplace/Info/MarketplaceInfo';
import { Spinner } from 'components/UI/Spinner/Spinner';
import { useMarketplace } from 'hooks/useMarketplace';
import { useOnlineBookingState } from 'hooks/useOnlineBookingState';
import React from 'react';
import { dispatch } from 'store';
import { AlertScreen } from 'types/Alert';
import { Customer } from 'types/Customer';
import { createOnlineBookingCustomerThunk } from 'actions/onlineBooking/actions/OnlineBookingCustomerActions';
import { navigateToStep } from 'actions/onlineBooking/actions/OnlineBookingFlowActions';
import { OnlineBookingFooter } from 'components/OnlineBooking/Footer/OnlineBookingFooter';
import { OnlineBookingHeader } from 'components/OnlineBooking/Header/OnlineBookingHeader';
import { OnlineBookingResume } from 'components/OnlineBooking/Resume/OnlineBookingResume';
import { OnlineBookingStep } from 'types/OnlineBooking';

export const OnlineBookingSignupStep: React.FC = () => {
    const marketplace = useMarketplace();
    const { isPending, customer } = useOnlineBookingState();

    const formRef = React.useRef<HTMLFormElement>(null);

    const [isValid, setIsValid] = React.useState(false);

    const triggerSubmit = () => {
        if (formRef.current) {
            formRef.current.submit();
        }
    };

    const submitHandler = React.useCallback((customer: Customer) => {
        dispatch(createOnlineBookingCustomerThunk(customer));
    }, []);

    const backHandler = React.useCallback(() => {
        dispatch(navigateToStep(OnlineBookingStep.Home));
    }, []);

    return (
        <TwoColumnsLayout header={<OnlineBookingHeader onBack={backHandler} />}>
            <LeftColumn contentClassName="flex flex-col flex-1">
                <h1 className="h1 underlined w-full">Personal info</h1>

                {isPending && (
                    <div className="w-full text-center mt-6">
                        <Spinner size={50} />
                    </div>
                )}

                {!isPending && (
                    <>
                        <ErrorList screen={AlertScreen.OnlineBookingSignup} className="mt-4 mb-2" />

                        <CustomerForm
                            ref={formRef}
                            defaultValues={customer}
                            onChange={setIsValid}
                            onSubmit={submitHandler}
                        />
                    </>
                )}

                <div className="pt-6 mt-auto hide-on-mobile-and-tablet">
                    <PoweredByCuddles />
                </div>
            </LeftColumn>

            <RightColumn
                poweredByCuddles
                footer={<OnlineBookingFooter disabled={!isValid} onSubmit={triggerSubmit} />}
            >
                <div className="flex flex-col gap-5 hide-on-mobile-and-tablet">
                    <MarketplaceInfo inverted marketplace={marketplace} />

                    <OnlineBookingResume />
                </div>
            </RightColumn>
        </TwoColumnsLayout>
    );
};
